<script>
import { fandomBasicMixin } from 'src/modules/fandom_mixins_module.js'
import YoutubeInplaceWindow from "youtube-inplace-window";

export default {
  mixins: [fandomBasicMixin],
  components: {
    YoutubeInplaceWindow
  },
  data: function() {
    return {
      active: false,
      play: false,
    };
  },
  created() {
    this.active = this.initActive();
  },
  mounted() {
    Vue.nextTick(() => {
      this.registerAnimation();
    });
  },
  methods: {
    getContentResponsiveImageURL: Fandom.getContentResponsiveImageURL,
    initActive() {
      let state = sessionStorage.getItem("one-col-media-collapsable-state") || "[]";
      state = JSON.parse(state);
      return !state.includes(this.contentId);
    },
    toggleActive() {
      let state = sessionStorage.getItem("one-col-media-collapsable-state") || "[]";
      state = JSON.parse(state);
      if (state.includes(this.contentId)) {
        this.active = true;
        state.splice(state.indexOf(this.contentId), 1);
      } else {
        this.active = false;
        state.push(this.contentId);
      }
      sessionStorage.setItem("one-col-media-collapsable-state", JSON.stringify(state));
    },
    closeYoutubeWindow() {
      this.play = false;
      this.toggleActive();
    }
  }
};
</script>

<template>
  <div v-easyadmin="easyadminId" :class="contentType" class="inview_animate" v-if="isContentVisibleToUser()" stripe-one-col-media-collapsable-component>
    <div @click="() => { if (active) play = true }" class="cursor-pointer">
      <div class="container-fluid">
        <div class="row justify-content-center" :class="{'mx-0': content.boxed}">
          <div class="col-12 px-0" :class="{'col-md-8': content.boxed}">
            <div class="collapsable-container position-relative" :class="{'h-100vh-header': active, 'h-60vh': !active}">
              <div class="position-absolute-center bg-cover-center w-100 h-100 inview_animate_zoom" :style="{'background-image': getContentResponsiveImageURL('image')}"></div>
              <div class="w-100 h-100 position-absolute-center layer"></div>  
              <div class="centered-animated-content" >
                <div class="row w-100 justify-content-center mx-0">
                  <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut">
                    <div class="col-12 text-center animated-play" v-if="active"><i class="fal fa-play-circle mx-auto"></i></div>
                  </transition>
                  <img v-if="content.icon" :src="expandUrl(content.icon.url)" class="mb-4 header-icon" />
                  <h2 v-if="content.title && !content.icon" class="col-12 col-md-6 text-center mb-0 display-2 text-white">{{content.title}}</h2>
                </div>
              </div>
              <div class="position-absolute-center">
                <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut">
                  <youtube-inplace-window v-if="play" :content="content" :opt-container-content="containerContent" @close="closeYoutubeWindow()"></youtube-inplace-window>
                </transition>
              </div>
              <div @click.stop="toggleActive" class="activation-state text-center w-100">
                <i class="fal fa-long-arrow-down activation-state-arrow text-white" :class="{'rotate-180': !active}"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
[stripe-one-col-media-collapsable-component] {
  color: $white;
  position: relative;

  .centered-animated-content {
    top: 50%;
    transform: translateY(-50%);
    position: absolute;
    left: 0;
    right: 0;

    .fal.fa-play-circle {
      color: $white;
      font-size: 5rem;
      position: absolute;
      left: 0;
      right: 0;
      top: -7rem;
    }
  }

  .header-icon {
    width: 15rem;
    max-width: 50%;
  }

  .activation-state {
    position: absolute;
    bottom: 0;
    padding-bottom: 4rem;

    .animated-text-footer {
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;

      & > small {
        font-weight: 300;
      }
    }

    .activation-state-arrow {
      transition: transform $animation-time-medium;
      
      &.rotate-180 {
        transform: rotate(180deg);
      }
    }

    @include media-breakpoint-down(sm) {
      padding-bottom: 2rem;
    }
  }

  .collapsable-container {
    background-position: bottom;
    transition: height $animation-time-medium;
    overflow: hidden;
  }
}
</style>